import React, { useCallback, useEffect, useState } from "react";
import { qrtListMessages } from "../../apis/qrtAdmin";
import { Pager, Spinner, StatusChip, fmtDateTime } from "./qrtUi";
import { ScopedPage } from "./QrtScopedPage";

const PAGE_SIZE = 50;

const MessagesTable = ({ userId }) => {
  const [data, setData] = useState({ rows: [], total: 0 });
  const [direction, setDirection] = useState("");
  const [campaignId, setCampaignId] = useState("");
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await qrtListMessages({
        user_id: userId, limit: PAGE_SIZE, offset: page * PAGE_SIZE,
        ...(direction ? { direction } : {}),
        ...(campaignId ? { campaign_id: campaignId } : {}),
      });
      setData(res.data?.data || { rows: [], total: 0 });
    } catch (_) {}
    finally { setLoading(false); }
  }, [userId, direction, campaignId, page]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  useEffect(() => { setPage(0); }, [userId]);

  return (
    <div className="qrt-card">
      <div className="qrt-card-head">
        <h3>Filters</h3>
        <input type="text" placeholder="Campaign ID" value={campaignId} inputMode="numeric"
          onChange={(e) => { setCampaignId(e.target.value.replace(/\D/g, "")); setPage(0); }}
          style={{ width: 110 }} />
        <select value={direction} onChange={(e) => { setDirection(e.target.value); setPage(0); }}>
          <option value="">Both directions</option>
          <option value="outbound">Outbound</option>
          <option value="inbound">Inbound</option>
        </select>
      </div>
      {loading ? <Spinner /> : (
        <table className="qrt-table">
          <thead>
            <tr>
              <th>Direction</th>
              <th>Customer</th>
              <th>Type</th>
              <th>Preview</th>
              <th>Campaign</th>
              <th className="r">Time</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((msg) => (
              <tr key={msg.id}>
                <td><StatusChip value={msg.direction} /></td>
                <td>
                  <div>{msg.customer_name || "—"}</div>
                  <div className="sub mono">{msg.customer_wa_id}</div>
                </td>
                <td className="mono">{msg.message_type}</td>
                <td className="sub" style={{ maxWidth: 320, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {msg.template_name ? `[${msg.template_name}] ` : ""}{msg.message_preview || "—"}
                </td>
                <td className="mono sub">{msg.campaign_id || "—"}</td>
                <td className="r sub">{fmtDateTime(msg.created_at)}</td>
              </tr>
            ))}
            {data.rows.length === 0 && (
              <tr><td className="empty" colSpan={6}>No messages for this user</td></tr>
            )}
          </tbody>
        </table>
      )}
      <Pager page={page} total={data.total} pageSize={PAGE_SIZE} onPage={setPage} />
    </div>
  );
};

const QrtMessages = () => (
  <ScopedPage title="Messages" noun="messages">
    {(userId) => <MessagesTable userId={userId} />}
  </ScopedPage>
);

export default QrtMessages;
